<nb-card>
  <nb-card-header>Switch To Role</nb-card-header>
  <nb-card-body>
    <div class="text-center m-t-20">

      <b>Do you want to switch the role to <span
          style="text-transform: capitalize; font-weight: bold;">{{role.replace('_',' ').toLowerCase()}}</span>?</b>
    </div>
    <!-- <div class="text-center m-t-20">
      <mat-checkbox color="accent" [(ngModel)]="isMain">
       I want to make <span
       style="text-transform: capitalize; font-weight: bold;">{{role.replace('_',' ').toLowerCase()}}</span> as the main role for Sign In
      </mat-checkbox>
    </div> -->
  </nb-card-body>
  <nb-card-footer>
    <div class="modal-footer">
      <button nbButton matRipple ghost status="warning" (click)="dismiss(false)">Cancel</button>
      <button nbButton matRipple status="primary" #yesButton id="yesButton" (click)="dismiss(true)">Confirm</button>
    </div>
  </nb-card-footer>
</nb-card>